import { BaseDeviceWrapper } from './BaseDeviceWrapper';
import image from 'images/devices/pleasure-drive-promotion.png';

const serviceUuid = 0xffe5;
const motorCharUuid = 0xffe9; // motor controlling characteristic

const infoServiceUuid = 0xff90;

const names = ['Pleasure-drive'];
const IDLE_TIMEOUT_BEFORE_AUTO_CONTROL_MODE = 2000; // timeout in milliseconds before switching toy to ambient mode

/**
 * Create a device wrapper over the Web Bluetooth device object
 * @param {obj} webBleDevice - Web Bluetooth device object
 */
export default class PleasureDrive extends BaseDeviceWrapper {
  ambientIdleTimeout: null | NodeJS.Timeout;
  ambientIntensity: number;
  removePowerControl: boolean;

  constructor(device) {
    super(device, serviceUuid, motorCharUuid, image);
    this.ambientIdleTimeout = null;
    this.ambientIntensity = 0;
    this.removePowerControl = true;
  }

  static get deviceNames() {
    return names;
  }

  /**
   * Needed to request access to these services before connecting to the device
   */
  static get services() {
    return [serviceUuid, infoServiceUuid];
  }

  get companyName() {
    return 'Kiiroo';
  }
  async connect() {
    await super.connect();
  }

  async disconnect() {
    await super.disconnect();
  }

  async write(percent) {
    let intensity = 0;

    if (percent > 0) {
      clearTimeout(this.ambientIdleTimeout);
      this.ambientIdleTimeout = null;

      intensity = percent;
    } else {
      // no penetration -> set 0 to the device and start timeout to use Auto Control
      if (!this.ambientIdleTimeout && this.ambientIntensity) {
        this.ambientIdleTimeout = setTimeout(async () => {
          if (this.ambientIntensity) {
            this.writeValue(this.ambientIntensity);
          }
        }, IDLE_TIMEOUT_BEFORE_AUTO_CONTROL_MODE);
      }
    }
    this.writeValue(intensity);
  }
  async writeValue(percent: number): Promise<void> {
    //because the normal percent was to fast, I put maxSpeed
    const maxDeviceSpeed = 50;
    const curved = Math.pow(percent / 100, 3);
    const speed = Math.round(curved * maxDeviceSpeed);

    // If signal is below ambient movement threshold, vibrate it with ambient movement
    // intensity
    const header = 0xcc;
    const command = 0x03;
    const checksum = (command + speed) & 0xff;

    const array = new Uint8Array([header, command, speed, checksum]);
    try {
      await this.motorChar.writeValue(array);
    } catch (error) {
      console.log(error);
    }
  }
  async setAmbientMovement(percent: number): Promise<void> {
    this.ambientIntensity = percent;
    if (this.ambientIdleTimeout) {
      this.writeValue(percent);
    }
  }
  async setMaxIntensity(percent: number): Promise<void> {}

  async writePaused() {
    clearTimeout(this.ambientIdleTimeout);
    this.ambientIdleTimeout = null;

    await this.write(0);
  }
}
